import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Patreon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.508,
    cy: 9.831,
    r: 6.496
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.996 3.335H6.17v17.33H2.996z"
  }));
});
Patreon.displayName = 'Patreon';
export var PatreonDimensions = {
  height: 24,
  width: 24
};